import React from 'react';
import  { styled } from 'styled-components';
import theme from '../theme';
import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';


import {ReactComponent as IconMenuBar} from '../assets/icons/iconmonstr-log-out-9.svg';
import { useNavigate } from 'react-router-dom';


const Btn = styled.button`

display: block;
width: 3.12rem;
height: 3.12rem;
line-height: 3.12rem;
text-align: center;
border: none;
background-color: ${theme.red};
color: #fff;
display: flex;
align-items: center;
justify-content: center;
border-radius: 0.31rem;
margin-left: 10px;
cursor: pointer;

@media(max-width: 60rem){
    width: 2.5rem;
    height: 2.5rem,;
    line-height: 2.5rem;
}
`

const Icono = styled(IconMenuBar)`
width: 50%;
height: auto;
fill: #fff;
`


const BtnLogOut = () => {

 const navigate = useNavigate();
 const logOut = async () => {
    try {
        await signOut(auth);
        localStorage.removeItem('menu');
        navigate('/inicio-sesion');
    } catch (error) {
        
    }
 }

    return ( <Btn onClick={logOut}><Icono></Icono></Btn> );
}
 
export default BtnLogOut;